<template>
  <SSLMobileView
      v-if="currentName === 'SSLView'"
      @acted="acted"
  />

  <main v-else class="kb-main" id="kb-prep" >
    <div class="main-content">
      <div class="ssl-body pb-0" :id="mainId">
        <SSLMobileSlotHeader>
          <template v-slot:title>
            <!--            <SSLMobileNav />-->
          </template>
          <template v-slot:left>
              <router-link :to="{name: 'SSLHome'}" class="util-actions util-actions-history-back">
                <i class="icon-history-back"></i>SSL 홈
              </router-link>
          </template>
          <template v-slot:right>
          </template>
        </SSLMobileSlotHeader>

        <div class="page-intro page-intro-black">
          <div class="intro-content">
            <div class="page-component"  style="display: flex;flex-direction: row">
              <img src="@/assets/lxp/images/ssl/reward/reward_leaf_black_L.png" alt="" style="width:50px;margin-right: 80px;">
              <h2 class="intro-title black-title" style="position: absolute">
                상반기 SSL AWARDS
              </h2>
              <img src="@/assets/lxp/images/ssl/reward/reward_leaf_black_R.png" alt="" style="width:50px;margin-left: 80px;">
            </div>
          </div>
          <div class="intro-background"></div>
        </div>
        <article>
          <div style="display: flex; width: 100%; overflow-x: auto; padding: 15px;">
            <a class="kb-btn kb-btn-wide rounded-lg loadmap-btn" href="javascript:" @click="selTap=-1" :style="selTap==-1?'background-color: #E8e8e8;':''">
              <span class="text">대상자<i class="icon-arrow" style="height: 17px;"></i></span>
            </a>
            <a class="kb-btn kb-btn-wide rounded-lg loadmap-btn" href="javascript:" @click="goFilter(0)" :style="selTap==0?'background-color: #E8e8e8;':''">
              <span class="text">전체<i class="icon-arrow" style="height: 17px;"></i></span>
            </a>
            <div v-for="(rwdPart, idx) in rewardParts" style="margin-right: 5px;"  :key="idx">
              <a class="kb-btn kb-btn-wide rounded-lg loadmap-btn" href="javascript:" @click="goFilter(rwdPart.lrnTrgtGrpMstSn)" :style="selTap==rwdPart.lrnTrgtGrpMstSn?'background-color: #E8e8e8;':''">
                <span class="text">{{ rwdPart.crseNm }}<i class="icon-arrow" style="height: 17px;"></i></span>
              </a>
            </div>
          </div>
        </article>

        <div class="page-container">
          <SSLMobileTotBoardList
              v-if="selTap >= 0"
              :is-loading="isLoading"
              :items="viewBoardItems"
              :paging="paging"
              :more-func="moreFunc"
          />

          <SSLMobileRewardMember v-if="selTap < 0" />

        </div>
      </div>
    </div>
  </main>

</template>
<script>
import SSLMobileView from '@/views/ssl/mobile/SSLMobileView';
import {sslRewardNoteSetup} from '@/assets/js/modules/ssl/setup/ssl-best-note-setup';
import SSLMobileSlotHeader from '@/components/ssl/main/mobile/SSLMobileSlotHeader';
import SSLMobileTotBoardList from "@/components/ssl/main/mobile/SSLMobileTotBoardList.vue";
import SSLMobileRewardMember from "@/components/ssl/reward/mobile/SSLMobileRewardMember";

export default {
  name: 'SSLMobileRewardNotes',
  components: {
    // SSLMobileNav,
    SSLMobileSlotHeader,
    SSLMobileView,
    SSLMobileTotBoardList,
    SSLMobileRewardMember
  },
  setup: sslRewardNoteSetup
}
</script>
